import { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import MainLayout from '../components/layout/MainLayout';
import { showAppError } from '../services/messageDialogService';
import AppHeader, { defaultUserAvatar } from '../components/layout/AppHeader';
import { fetchUserProfile } from '../services/authService';
import { trackEvent } from '../services/clevertapService';
import { clearAuthSession, setAuthToken } from '../storage/authStorage';
import { BAZZAR_MOBILE_PATH } from '../routes/paths';

export default function VerifyTokenPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('Saving token...');
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      showAppError('Missing token in URL.');
      navigate('/', { replace: true });
      return undefined;
    }

    let cancelled = false;

    const loginWithToken = async () => {
      try {
        setAuthToken(token);
        setStatus('Loading profile...');

        const profile = await fetchUserProfile();
        if (cancelled) return;

        trackEvent('Token Verified', {
          Source: 'verify-token',
          Method: 'token',
        });

        setStatus('Redirecting...');
        navigate(BAZZAR_MOBILE_PATH, {
          replace: true,
          state: { profileLoaded: true, userId: profile?.userId || profile?.cognitoId || null },
        });
      } catch (error) {
        if (cancelled) return;
        clearAuthSession();
        showAppError(error?.message || 'Unable to verify token.');
        navigate('/', { replace: true });
      }
    };

    loginWithToken();

    return () => {
      cancelled = true;
    };
  }, [navigate, token]);

  return (
    <MainLayout>
      <AppHeader showSubtitle endVariant="profile" avatarSrc={defaultUserAvatar} />
      <Box
        sx={{
          minHeight: { xs: '68vh', md: '72vh' },
          display: 'grid',
          placeItems: 'center',
          py: { xs: 2, md: 5 },
        }}
      >
        <Box sx={{ textAlign: 'center' }}>
          <CircularProgress sx={{ color: '#FF00F2', mb: 2 }} />
          <Typography sx={{ color: '#fff', fontSize: 16, letterSpacing: '0.8px' }}>{status}</Typography>
        </Box>
      </Box>
    </MainLayout>
  );
}
